module.exports = __webpack_public_path__ + "img/2_1.bd817f03.jpg";